<template>
  <div
    class="row"
  >
    <div class="col-6">
      <RsFormCalendarCustom
        :id="`${id}_from`"
        :disabled="disabled"
        :max-date="limit"
        :value="minValue"
        :label="$ts('dates.range.from')"
        @input="setDate($event, 'min')"
      />
    </div>

    <div class="col-6">
      <RsFormCalendarCustom
        :id="`${id}_to`"
        :disabled="disabled"
        :max-date="limit"
        :value="maxValue"
        :label="$ts('dates.range.to')"
        @input="setDate($event, 'max')"
      />
    </div>

    <div
      v-show="!isDateRangeValid(maxValue, minValue)"
      class="col-12"
    >
      <span class="rs-text-error">
        * <strong>{{ $ts('dates.validation.endDateRange') }}</strong> {{ $ts('dates.validation.cannotBeBefore') }} <strong>{{ $ts('dates.validation.startDateRange') }}</strong>
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import dayjs from 'dayjs';
import {
  isDateRangeValid,
} from '@/shared';

const now = dayjs();

export default defineComponent({
  name: 'RsDateRange',

  props: {
    id: {
      type: String,
      required: true,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
    // handles unix timestamps
    unix: {
      type: Boolean,
      default: false,
    },

    // min date
    dateFrom: {
      type: [String, Number, Date, Object],
      default: '',
    },
    // max date
    dateTo: {
      type: [ String, Number, Date, Object],
      default: '',
    },

    // max date limit --- set to today's date as default
    limit: {
      type: String,
      default: now.format('YYYY-MM-DD'),
    },
  },

  data() {
    return {
      isDateRangeValid,
      minValue: '' as string,
      maxValue: '' as string,
    };
  },

  watch: {
    dateFrom: {
      immediate: true,
      handler() {
        if (this.unix) {
          this.minValue = this.convertUnixToDateTime(this.dateFrom as string);
        } else {
          this.minValue = this.dateFrom as string;
        }
      },
    },

    dateTo: {
      immediate: true,
      handler() {
        if (this.unix) {
          this.maxValue = this.convertUnixToDateTime(this.dateTo as string);
        } else {
          this.maxValue = this.dateTo as string;
        }
      },
    },

  },

  methods: {
    convertUnixToDateTime(value: string) {
      return dayjs.unix(parseInt(value, 10)).format('MM/DD/YYYY');
    },

    setDate(data: string, type: 'min' | 'max'): void {
      if (this.unix) {
        if (type === 'min') {
          this.$emit('on-min-date-change', dayjs(data).unix());
        } else {
          this.$emit('on-max-date-change', dayjs(data).unix());
        }
      } else {
        // eslint-disable-next-line no-lonely-if
        if (type === 'min') {
          this.$emit('on-min-date-change', dayjs(data).format('YYYY-MM-DD'));
        } else {
          this.$emit('on-max-date-change', dayjs(data).format('YYYY-MM-DD'));
        }
      }
    },
  },

});
</script>
